import Vue from 'vue'
import App from './App.vue'
import vWow from 'v-wow'
import i18n from './i18n'
import whatInput from 'what-input'
import VueMatchHeights from 'vue-match-heights'
import VueGtm from 'vue-gtm'
import VueNumber from 'vue-number-animation'
import VueMeta from 'vue-meta'

Vue.use(VueNumber)

require('vue2-animate/dist/vue2-animate.min.css')
Vue.use(VueMeta)

Vue.use(VueGtm, {
	id: 'GTM-N4SMKWJ',
	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
})

Vue.use(vWow)
Vue.use(whatInput)

Vue.config.productionTip = false

Vue.use(VueMatchHeights, {
	disabled: [767],
})

new Vue({
	i18n,
	render: h => h(App),
}).$mount('#app')